<template>
    <div id="payment-plan-component">
        <b-modal v-model="showModal" hide-footer size="xl" centered scrollable :title="titleModal">
            <form id="formCrud" class="formCrud">
                <div class="row ">
                    <div class="col-12 col-md-6 col-xl-6">
                        <input id="nombre-plan" type="text" class="al-inputs required scr-input"
                               placeholder="Nombre del Plan" v-model="paymentPlan.nombre"/>
                        <label for="nombre-plan" class="scr-supertext scr-extra">Nombre del Plan</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-6">
                        <input type="text" class="al-inputs scr-input" placeholder="Meses" v-model="paymentPlan.meses"
                               id="ap1"/>
                        <label for="ap1" class="scr-supertext scr-extra">Meses</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-6">
                        <input type="text" class="al-inputs scr-input" placeholder="Porcentaje"
                               v-model="paymentPlan.porcentaje" id="ap"/>
                        <label for="ap" class="scr-supertext scr-extra">Porcentaje</label>
                    </div>
                    <div class="col-12 col-md-6 col-xl-6">
                        <select v-model="paymentPlan.visible_for" name="" id="">
                            <option :value="0">Selecciona una Opción</option>
                            <option :value="2">Publico</option>
                            <option :value="1">Admin</option>
                        </select>
                    </div>
                    <div class="col-12 col-md-6 col-xl-12">
                        <button id="dyn-button" type="button" class="formSubmit" v-on:click="guardar()">{{
                                tituloBtn
                            }}
                        </button>
                    </div>
                </div>
            </form>
        </b-modal>
        <main id="mainContent" class="padFixBoth">
            <div class="view ">
                <div class="barSettings">
                    <div class="row">
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0">
                           <b-pagination pills align="fill" :hide-goto-end-buttons="true" :limit="3" v-model="pagination.current_page"
                                          :total-rows="pagination.total" :per-page="pagination.per_page"
                                          aria-controls="my-table" v-on:change="onChange"></b-pagination>
                        </div>
                        <div class="col-12  col-xl-6 mb-3 mb-sm-0">
                            <input id="filter-input" class="al-inputs scr-input" v-model="filter" type="search"
                                   placeholder="Buscar por palabra">
                            <label for="filter-input" class="scr-supertext scr-extra">Buscar por palabra</label>
                        </div>
                        <div class="col-12 col-xl-2 mb-3 mb-sm-0 cont_select">
                            <select id="change_result" class="float" v-model="params.limit" v-on:change="changeLimit">
                                <option :value="10">10</option>
                                <option :value="20">20</option>
                                <option :value="30">30</option>
                                <option :value="50">50</option>
                                <option :value="100">100</option>
                            </select>
                        </div>
                        <div class="col-md-2">
                            <button type="button" class="formSubmit" v-on:click="openModalsProviders()">Agregar</button>
                        </div>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="row">
                        <b-table responsive id="my-table" striped hover :fields="fields" :filter="filter" :busy="isBusy"
                                 :items="pagination.data" show-empty>
                            <template #empty="scope">
                                <h4 class="emptyRow">
                                    No hay datos para mostrar.
                                </h4>
                            </template>
                            <template #cell(Nombre)="{item}">
                                <span>{{ item.nombre }}</span>
                            </template>
                            <template #cell(Meses)="{item}">
                                <span>{{ item.meses }}</span>
                            </template>
                            <template #cell(Porcentaje)="{item}">
                                <span>{{ item.porcentaje }}</span>
                            </template>
                            <template #cell(Visible)="{item}">
                                <span v-if="item.visible_for===2" class="badge rounded-pill text-bg-info">Publico</span>
                                <span v-else class="badge rounded-pill text-bg-success">Admin</span>
                            </template>
                            <template #cell(Acciones)="{item}">
                                <div class="dropdown">
                                    <button class="btn btn-warning dropdown-toggle" type="button"
                                            id="dropdownMenuButton"
                                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                        <i class="fas fa-cogs"></i>
                                    </button>
                                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="modificar=true;updateReg(item)">Editar</a>
                                        <a class="dropdown-item" href="javascript:void(0)"
                                           v-on:click="onClickDelete(item.id)">Borrar</a>
                                    </div>
                                </div>
                            </template>

                            <template #table-busy>
                                <div class="text-center text-danger my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                        </b-table>
                    </div>
                </div>
            </div>

        </main>
    </div>
</template>

<script>
import {myMixins} from "../mixins/myMixins";
import {paymentplanService} from "../../Services/Paymentplan.service";

export default {
    name: "payment-plan",
    mixins: [myMixins],
    data() {
        return {
            filter: null,
            modificar: false,
            isBusy: false,
            tituloBtn: "Guardar",
            paymentPlan: {
                nombre: "",
                meses: "",
                porcentaje: "",
                visible_for: 0,
                id: '',
            },
            params: {
                limit: 10,
                page: 1,
                where: []
            },
            fields: [
                {key: "Nombre"},
                {key: "Meses"},
                {key: "Porcentaje"},
                {key: "Visible"},
                {key: "Acciones"}
            ],
            pagination: {
                current_page: 1,
                data: [],
                first_page_url: '',
                from: 0,
                last_page: 0,
                last_page_url: '',
                links: [],
                next_page_url: '',
                path: '',
                per_page: 0,
                prev_page_url: '',
                to: 0,
                total: 0,
            },
        };
    },
    methods: {
        updateReg(item) {
            console.log(item);
            this.paymentPlan = item;
            this.tituloBtn = "Actualizar";
            this.modificar = true;
        },
        async index() {
            //console.log(this.params);
            this.isBusy = true;
            this.pagination = await paymentplanService.getMany(this.params);
            this.isBusy = false;
        },
        async onClickDelete(id) {
            let resp = await paymentplanService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {

            let resp = '';
            let respVal = this.valFormulariosV3();

            //actualizando
            if (respVal) {
                this.disableSubmitBtn(true);
                if (this.modificar) {
                    resp = await paymentplanService.updateOne(this.paymentPlan.id, this.paymentPlan);
                } else {
                    resp = await paymentplanService.saveOne(this.paymentPlan);
                }
                this.disableSubmitBtn(false);
            }

            if (resp.process === 'success') {
                this.setEmpty();
                this.getAlert(resp.process);
                await this.index();
            } else {
                this.getAlert(resp.process);
            }
            this.modificar = false;

        },
        async onChange(page) {
            this.params.page = page;
            await this.index();
        },
        changeLimit() {
            this.index();
        },
        setEmpty() {
            this.paymentPlan = {
                nombre: "",
                meses: "",
                porcentaje: "",
                visible_for: 0,
                id: '',
            }
        }
    },
    mounted() {
        this.index();
    },
}
</script>

<style scoped>
form select {
    margin: 0 !important;
}
</style>
